import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bb32d5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onContextmenu"]
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = ["data-course-id", "data-page-id", "data-part-id", "data-exposure-time"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["src"]

import {onMounted, ref, onUnmounted, watch} from 'vue'
import {PageRecord} from "@/models/page/pageRecord";
import Video from "@/models/page/video";
import "vue3-video-play/dist/style.css";
// import {videoPlay} from "vue3-video-play";
import Player from "@/components/VideoPlayer/Player.vue";
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPage',
  props: {
    page: {},
    userPage: {},
    courseId: {},
    partId: {},
    pageId: {}
  },
  emits: ['count-time'],
  setup(__props: any, { emit: __emit }) {

const props = __props


const load = ref<boolean>(false)
const element = ref<Element>()

const options = {
  width: '100%',
  height: '480px',
  muted: false, //静音
  webFullScreen: false,
  speedRate: ["0.75", "1.0", "1.25", "1.5", "2.0"], //播放倍速
  autoPlay: false, //自动播放
  loop: false, //循环播放
  mirror: false, //镜像画面
  ligthOff: false, //关灯模式
  volume: 0.3, //默认音量大小
  control: true, //是否显示控制
  controlBtns: [
    "audioTrack",
    "quality",
    "speedRate",
    "volume",
    "setting",
    "pip",
    "pageFullScreen",
    "fullScreen",
  ], //显示所有按钮,
};

watch(load, (newVal) => {
  if (props.page.source === 'CC' && newVal) {
    setTimeout(() => {
      console.log(newVal);
      console.log(document.querySelector("#ccVideo" + props.page.id));
      window.createCCH5Player({
        vid: props.page.vid,
        siteid: "00CAF4FBAA354DB9",
        autoStart: true,
        width: "100%",
        height: "540px",
        parentNode: document.querySelector("#ccVideo" + props.page.id)
      })
    }, 200)
  }
})

const emits = __emit
let timeInterval;
let time = 0;

const countTime = () => {
  if (time > 0) {
    emits('count-time', {
      pageId: props.pageId,
      time,
    })
    time = 0;
  }
}

const onPlay = () => {
  timeInterval = setInterval(function () {
    time += 0.25
  }, 250)
}
const onPauseOrEnded = () => {
  clearInterval(timeInterval);
  countTime();
}

const addLazyLoad = () => {
  let lazyLoadMonitor = new IntersectionObserver((changes) => {
    changes.forEach((change) => {
      if (change.intersectionRatio > 0) {
        load.value = true
        lazyLoadMonitor.unobserve(change.target)
        lazyLoadMonitor.disconnect();
      }
    });
  });
  lazyLoadMonitor.observe(element.value)
}

onMounted(() => {
  window.scrollTo(0, 0)
  // 视频懒加载 + 视频元素曝光
  addLazyLoad()
  // 页面关闭上报时长
  window.addEventListener('beforeunload', countTime, false)
})

// 组件销毁上报时长
onUnmounted(() => {
  countTime()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "videoWrap",
    onContextmenu: _withModifiers(
            () => {
                return false;
            }
        , ["prevent"])
  }, [
    (_ctx.page.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.page.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "exposure lazy-load",
      ref_key: "element",
      ref: element,
      "data-course-id": _ctx.courseId,
      "data-page-id": _ctx.pageId,
      "data-part-id": _ctx.partId,
      "data-exposure-time": _ctx.userPage.exposureTime
    }, [
      (_ctx.page.source === 'CC' && load.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cc-video",
            id: 'ccVideo'+_ctx.page.id
          }, null, 8, _hoisted_4))
        : (load.value)
          ? (_openBlock(), _createBlock(Player, {
              key: 1,
              src: _ctx.page.path,
              poster: _ctx.page.poster,
              id: _ctx.partId + _ctx.pageId + '',
              onPlay: onPlay,
              onPause: onPauseOrEnded
            }, null, 8, ["src", "poster", "id"]))
          : (_openBlock(), _createElementBlock("img", {
              key: 2,
              class: "cover",
              src: _ctx.page.poster,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (load.value = true))
            }, null, 8, _hoisted_5))
    ], 8, _hoisted_3)
  ], 40, _hoisted_1))
}
}

})